import React, {  useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./catalogs.css";
import { useNavigate } from 'react-router-dom';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-resizable/css/styles.css';
import { Tab, Tabs } from 'react-bootstrap';
import Assignments from '../Tasks/I94Validation/Assignments';
import TaskDisccuss from '../Tasks/I94Validation/TaskDisccuss';
import TaskKnowledge from '../Tasks/I94Validation/TaskKnowledge';
import TaskHistory from '../Tasks/I94Validation/TaskHistory';
function ReportBtex() {
    const navigate = useNavigate();
    // const [formData, setFormData] = useState({
    //     request_type: 'report_technical_issue',
    //     issue: '',
    //     issue_date: '',
    //     short_description: '',
    //     description: '',
    // });
    const [typedata, setTypeData] = useState("my_article");
    const [activeTab, setActiveTab] = useState("overview");
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <div className='validate_dragers'>
                <div className='d-flex flex-column'>
                  <h5>Global</h5>
                  <span className="">
                      <img src={require('../../../assets/circlecheck.svg').default} alt=""/>
                        Correct My Profile</span>
                  <span className="span_greenonbact">
                      <img src={require('../../../assets/circleprocess.svg').default} alt=""/>
                        Marketing Hold Request</span>
                  <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Report Technical Issues</span>
              </div>
              <div className='d-flex flex-column border_catsvalidate'>
                <h5>Jobseeker Services</h5>
                <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Correct My Profile</span>
                <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Marketing Hold Request</span>
                <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Report Technical Issues</span>
                <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Edit Registration</span>
                <span className="span_disabledrager">
                      <img src={require('../../../assets/circleminus.svg').default} alt=""/>
                        Learn about BenchTrack Certifications</span>
              </div>
            </div>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate(-1)}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> Report Technical Issues</span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker">
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn mb-4">
                        <div className='knowledgetab_btnredirect mt-4'>
                            <button className={typedata === "my_article" ? "active_tabbtn" : ""} onClick={()=>setTypeData("my_article")}>TASK1002</button>
                            <button className={typedata === "my_group" ? "active_tabbtn" : ""} onClick={()=>setTypeData("my_group")}>CASE1001</button>
                        </div>
                    </Grid>
                    <Grid size={{sm:12}} container className="main_jobseeker_expe">
                        <Grid size={{sm:12}} container alignItems="center">
                            <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={(key) => setActiveTab(key)}
                                    defaultActiveKey="overview"
                                    id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                    >
                                    <Tab eventKey="overview" title="Overview">
                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="i94viewvalidate">
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Case Number<small>*</small></span>
                                                <p>Case10000</p>
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Jobseeker<small>*</small></span>
                                                <p>Stew Thomas</p>
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Title<small>*</small></span>
                                                <p>International Travel</p>
                                            </Grid>
                                            
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Case Status<small>*</small></span>
                                                <p>In Progress</p>
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Case Open Date<small>*</small></span>
                                                <p>09-25-2024</p>
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Case Opened by<small>*</small></span>
                                                <p>Member 1</p>
                                            </Grid>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Case Closed<small>*</small></span>
                                                <p>09-25-2024</p>
                                            </Grid>
                                        </Grid>
                                    </Tab>
                                    <Tab eventKey="assignment" title="Assignments">
                                        {activeTab === "assignment" && <Assignments />}
                                    </Tab>
                                    <Tab eventKey="discussions" title="Discussions">
                                        {activeTab === "discussions" && <TaskDisccuss />}
                                    </Tab>
                                    <Tab eventKey="knowledge" title="Knowledge">
                                        {activeTab === "knowledge" && <TaskKnowledge />}
                                    </Tab>
                                    <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                        {activeTab === "history" && <TaskHistory />}
                                    </Tab>
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>
  )
}

export default ReportBtex
